import styled from "styled-components";

interface IInput {
  placeholder: string;
  onChange: Function;
  addonCss?: any;
  disabled?: boolean;
  value?: any;
}
const Input = ({
  placeholder,
  onChange,
  value,
  addonCss,
  disabled = false,
}: IInput) => {
  return (
    <SContainer className={disabled ? "disabled" : ""} style={addonCss}>
      <SInput
        disabled={disabled}
        placeholder={placeholder}
        value={value}
        onChange={(e: any) => {
          onChange(e.target.value);
        }}
      />
    </SContainer>
  );
};
export default Input;
const SContainer = styled.div`
  width: 100%;
  border: 1px solid var(--color-border);
  background-color: var(--color-surface);
  height: 100%;
  min-height: 40px;
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  padding: 0 14px;
  transition:
    border-color var(--transition),
    box-shadow var(--transition),
    background-color var(--transition);

  &:hover {
    border-color: var(--color-border-strong);
  }
  &:focus-within {
    border-color: var(--color-primary);
    box-shadow: 0 0 0 3px var(--color-primary-ring);
  }
  &.disabled {
    background-color: var(--color-surface-alt);
    color: var(--color-text-muted);
  }
`;
const SInput = styled.input`
  &:focus {
    outline: none;
  }
  &::placeholder {
    color: var(--color-text-subtle);
    font-family: inherit;
  }
  color: var(--color-text);
  background: transparent;
  border: none;
  width: 100%;
  height: 100%;
  padding: 8px 0;
  font-size: 14px;
`;
